import { HttpInterceptorFn, HttpResponse } from '@angular/common/http';
import { Subject, filter, finalize, tap } from 'rxjs';

const requests = new Map<string, Subject<HttpResponse<any>>>();

const getCacheKey = (req: { method: string; urlWithParams: string; body: any }) => {
    return `${req.method}|${req.urlWithParams}|${JSON.stringify(req.body ?? null)}`;
};

export const httpCacheInterceptor: HttpInterceptorFn = (req, next) => {
    const cacheKey = getCacheKey(req);
    const existing = requests.get(cacheKey);

    if (existing && !existing.closed) {
        return existing;
    }

    const data$ = new Subject<HttpResponse<any>>();
    requests.set(cacheKey, data$);

    return next(req).pipe(
        filter((x) => x instanceof HttpResponse),
        tap((x) => {
            const current = requests.get(cacheKey);
            !current?.closed && current?.next(x as HttpResponse<any>);
        }),
        finalize(() => {
            const current = requests.get(cacheKey);
            current?.complete();
            current?.unsubscribe();
            requests.delete(cacheKey);
        })
    );
};
